import { Typography as MUITypography, TypographyProps } from '@mui/material';

export { type TypographyProps } from '@mui/material';

export function Typography(props: TypographyProps) {
  return <MUITypography {...props} />;
}
